export function MembershipStatusBadge({ value }: { value?: string | null }) {
  const status = value ?? "UNKNOWN";

  const className =
    status.includes("ACTIVE") ||
    status.includes("CONFIRMED") ||
    status.includes("COMPLETED") ||
    status.includes("APPROVED")
      ? "border-emerald-100 bg-emerald-50 text-emerald-700"
      : status.includes("PENDING") ||
          status === "PROSPECT" ||
          status.includes("REVIEW")
        ? "border-amber-100 bg-amber-50 text-amber-700"
        : status.includes("REJECTED") ||
            status.includes("SUSPENDED") ||
            status.includes("INACTIVE")
          ? "border-red-100 bg-red-50 text-red-700"
          : "border-slate-100 bg-slate-50 text-slate-700";

  return (
    <span className={`rounded-full border px-3 py-1 text-xs font-black ${className}`}>
      {status.replaceAll("_", " ")}
    </span>
  );
}